module.exports = __webpack_public_path__ + "img/360.3c32801b.png";